module.exports = __webpack_public_path__ + "img/garden_dsj_1.fc803133.png";